<template>
  <div class="wrapper organization-page">
    <!-- Header -->
    <Header />
    <!-- HeaderMenu -->
    <HeaderMenu />

    <div class="contents">
      <div class="layout">
        <div class="left">
          <div class="pc-only">
            <Sidebar />
          </div>
        </div>
        <div class="right">
          <h1>{{ $t("ORGANIZATION CHART") }}</h1>
          <div class="chart">
            <form>
              <div class="btn-area">
                <div class="btn link-over">
                  {{ $t("Last on the left") }}
                </div>
                <div class="btn link-over">
                  {{ $t("Last on the right") }}
                </div>
                <div class="search-area">
                  <input type="text" name="" />
                  <span>
                    <img src="../assets/img/search-img2.png" alt="" />
                  </span>
                </div>
              </div>
              <!-- Top main -->
              <ul class="user-list list1">
                <li>
                  <div class="icon link-over" v-on:click="showBox">
                    <img src="../assets/img/chart-user-icon-img.png" alt="" />
                  </div>
                  <div
                    class="hidden-detail"
                    v-bind:class="{
                      active: active == true,
                    }"
                  >
                    <ul class="detail-list">
                      <li>{{ $t("ID") }}：</li>
                      <li><span>1000</span></li>
                    </ul>
                    <ul class="detail-list">
                      <li>{{ $t("PLAN") }}：</li>
                      <li>
                        <span>{{ $t("Bronze") }}</span>
                      </li>
                    </ul>
                    <ul class="detail-list">
                      <li>{{ $t("LEFT") }}：</li>
                      <li><span>500</span>USD</li>
                    </ul>
                    <ul class="detail-list">
                      <li>{{ $t("RIGHT") }}：</li>
                      <li><span>500</span>USD</li>
                    </ul>
                  </div>
                  <p class="name">YOU</p>
                </li>
              </ul>
              <!-- ./Top main -->
              <div class="wrap">
                <!-- Left User -->
                <div class="left-user">
                  <ul class="user-list list2">
                    <li>
                      <div class="icon link-over" v-on:click="showBox">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div
                        class="hidden-detail"
                        v-bind:class="{
                          active: active == true,
                        }"
                      >
                        <ul class="detail-list">
                          <li>{{ $t("ID") }}：</li>
                          <li><span>1000</span></li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("PLAN") }}：</li>
                          <li>
                            <span>{{ $t("Bronze") }}</span>
                          </li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("LEFT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("RIGHT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                      </div>
                      <p class="name">testuser-1</p>
                    </li>
                  </ul>
                  <ul class="user-list list3">
                    <li>
                      <div class="icon link-over" v-on:click="showBox">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div
                        class="hidden-detail"
                        v-bind:class="{
                          active: active == true,
                        }"
                      >
                        <ul class="detail-list">
                          <li>{{ $t("ID") }}：</li>
                          <li><span>1000</span></li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("PLAN") }}：</li>
                          <li>
                            <span>{{ $t("Bronze") }}</span>
                          </li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("LEFT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("RIGHT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                      </div>
                      <p class="name">testuser-3</p>
                      <div class="down-btn link-over">
                        {{ $t("Next") }}
                      </div>
                    </li>
                    <li>
                      <div class="icon link-over" v-on:click="showBox">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div
                        class="hidden-detail"
                        v-bind:class="{
                          active: active == true,
                        }"
                      >
                        <ul class="detail-list">
                          <li>{{ $t("ID") }}：</li>
                          <li><span>1000</span></li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("PLAN") }}：</li>
                          <li>
                            <span>{{ $t("Bronze") }}</span>
                          </li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("LEFT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("RIGHT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                      </div>
                      <p class="name">testuser-5</p>
                      <div class="down-btn link-over">
                        {{ $t("Next") }}
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- ./Left User -->
                <!-- Right User -->
                <div class="right-user">
                  <ul class="user-list list2">
                    <li>
                      <div class="icon link-over" v-on:click="showBox">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div
                        class="hidden-detail"
                        v-bind:class="{
                          active: active == true,
                        }"
                      >
                        <ul class="detail-list">
                          <li>{{ $t("ID") }}：</li>
                          <li><span>1000</span></li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("PLAN") }}：</li>
                          <li>
                            <span>{{ $t("Bronze") }}</span>
                          </li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("LEFT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                        <ul class="detail-list">
                          <li>{{ $t("RIGHT") }}：</li>
                          <li><span>500</span>USD</li>
                        </ul>
                      </div>
                      <p class="name">testuser-2</p>
                    </li>
                  </ul>
                  <ul class="user-list list3">
                    <li class="not-active">
                      <div class="icon link-over">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div class="active-btn link-over" v-on:click="show">
                        {{ $t("New") }}
                      </div>
                    </li>
                    <li>
                      <div class="icon">
                        <img
                          src="../assets/img/chart-user-icon-img.png"
                          alt=""
                        />
                      </div>
                      <div class="active-btn link-over" v-on:click="show">
                        {{ $t("New") }}
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- ./Right User -->
              </div>
            </form>
          </div>
          <div class="detail-history">
            <h2>
              {{ $t("Referral history") }}
              <router-link to="./referral" class="link-over">{{
                $t("Details")
              }}</router-link>
            </h2>
            <table>
              <tr>
                <th>{{ $t("Date") }}</th>
                <th>{{ $t("User") }}</th>
                <th>{{ $t("Position") }}</th>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>TEST</td>
                <td>左</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>TEST1</td>
                <td>右</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>TEST2</td>
                <td>左</td>
              </tr>
              <tr>
                <td>2020.04.10<br />12:23:32</td>
                <td>TEST3</td>
                <td>右</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- /.contents -->

    <modal
      name="codeModal"
      :resizable="true"
      :adaptive="true"
      :scrollable="true"
      width="90%"
      height="auto"
    >
      <div class="modal-box">
        <div class="modal-ttl">
          <p>{{ $t("REFERRAL CODE") }}</p>
        </div>
        <div class="code-area">
          <p>{{ $t("REFERRAL URL") }}</p>
          <div class="input-area">
            <input type="text" id="url" v-model="url" readonly />
          </div>
          <span
            class="copy-btn link-over"
            v-clipboard:copy="url"
            v-clipboard:success="urlCopy"
            v-clipboard:error="urlError"
            >COPY</span
          >
        </div>
        <div class="btn">
          <button v-on:click="hide" type="button" class="link-over">
            {{ $t("Close") }}
          </button>
        </div>
      </div>
    </modal>

    <Footer title="Organization" />
  </div>
</template>
<style scoped></style>
<script>
import Header from "@/components/Header.vue";
import HeaderMenu from "@/components/HeaderMenu.vue";
import Sidebar from "@/components/Sidebar.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "Organization",
  components: {
    Header,
    HeaderMenu,
    Sidebar,
    Footer,
  },
  data: () => {
    return {
      title: "Organization",
      active: false,
      url: "https://www.OOO.com/jfoweajfioj…",
    };
  },
  methods: {
    toggleAction() {
      this.active = !this.active;
    },
    showBox: function () {
      this.active = true;
      setTimeout(() => {
        this.active = false;
      }, 6000);
    },
    show: function () {
      this.$modal.show("codeModal");
    },
    hide: function () {
      this.$modal.hide("codeModal");
    },
    urlCopy: function (e) {
      alert("You just copied: " + e.text);
    },
    urlError: function () {
      alert("Failed to copy texts");
    },
  },
  computed: {},
  mounted: function () {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");

    var ua = navigator.userAgent.toLowerCase();
    var isiOS = ua.indexOf("iphone") > -1 || ua.indexOf("ipad") > -1;
    if (isiOS) {
      var viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        var viewportContent = viewport.getAttribute("content");
        viewport.setAttribute(
          "content",
          viewportContent + ", user-scalable=no"
        );
      }
    }
  },
};
</script>
